export class TicketModal {

    constructor() {
        this.btn = document.querySelector('.meld-je-aan');
        this.modal = document.querySelector('.page-event-detail .modal');
        
        if (this.btn && this.modal) {
            this.closeBtn = document.querySelector('.page-event-detail #close-modal')
            this.addEventListeners();
        }
    }
    
    addEventListeners() {
        this.btn.addEventListener('click', () => {
            this.modal.classList.remove('closing');
            this.modal.style.display = 'block';
        });

        this.closeBtn.addEventListener('click', () => {
            this.modal.classList.add('closing');
            setTimeout(() => {
                this.modal.style.display = 'none';
            }, 1000);
        });
    }
  
  }